import classNames from 'classnames';
import { dsClass } from '../../common/constants/dsClasses.js';
import { billingAccountAndUserMsg, t } from '../../common/i18n/index.js';
import { DetailsWithInfoColumn } from '../DetailsWithInfoColumn/DetailsWithInfoColumn.js';
import { ChangeContractOwnerView } from './Accordions/ChangeContractOwnerAccordion.js';
import { YttInstructionsCard } from './YttInstructions.js';
import type { CompanyInfoResponse } from '../../generated/api/companyInfoResponse.js';
import type { Subscription } from '../../generated/api/subscription.js';

export interface ServiceBillingAccountDetailsProps {
  companyInfo: CompanyInfoResponse;
  subscription: Subscription;
}

export const ServiceBillingAccountDetails = ({ companyInfo, subscription }: ServiceBillingAccountDetailsProps) => (
  <DetailsWithInfoColumn infoColumnContent={<YttInstructionsCard subscription={subscription} />}>
    <h3 className={classNames(dsClass.H3_BOOK, dsClass.MARGIN_BOTTOM_7)}>{t.CZ63(billingAccountAndUserMsg)}</h3>
    <ChangeContractOwnerView subscription={subscription} companyInfo={companyInfo} billingAccountLink />
  </DetailsWithInfoColumn>
);
